<template>
    <div class="row no-gutters mr-n4">
        <div v-for="(option, i) in searchOptions" :key="option.optionName" class="col-xl-4 col-md-6 mt-2 mb-2">
            <SearchOptionCard
                v-if="option.searchType !== 'Etymology'"
                class="mr-4 menu-item"
                :nrSelected="getNrSelectedItems(option)"
                :searchOption="option"
                :isSelected="isSelectedOption(option)"
                @onClick="cardClicked"
            />
            <SearchOptionToggle
                v-else
                class="mr-4 menu-item"
                :searchOption="option"
                :isSelected="isSelectedOption(option)"
                @toggleChanged="updateToggleTag"
            />
        </div>
    </div>
</template>
<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { EtymologyTag, ITag } from '../TagModel';
import SearchOptionCard from './SearchOptionCard.vue';
import { ISearchOption } from './searchOptions/SearchOptionModel';
import SearchOptionToggle from './SearchOptionToggle.vue';

const searchModule = namespace('search');

@Component({ components: { SearchOptionCard, SearchOptionToggle } })
export default class SearchOptionCardContainer extends Vue {
    @Prop()
    public searchOptions!: ISearchOption[];

    @searchModule.Getter
    private selectedSearchOption!: ISearchOption;

    @searchModule.Getter
    private searchTags!: ITag[];

    @Emit('activeOptionCardChanged')
    public cardClicked(clickedOptionCard: ISearchOption): void {
        return;
    }

    @searchModule.Action('updateTags')
    private updatetags!: ({
        tagsToAdd,
        tagsToRemove,
        replace,
    }: {
        tagsToAdd: ITag[];
        tagsToRemove: ITag[];
        replace: boolean;
    }) => Promise<void>;


    @Emit('toggleCardChanged')
    private async updateToggleTag(enabled: boolean): Promise<void> {
        const etymologyTag = EtymologyTag('true');

        if (enabled) {
            await this.updatetags({
                tagsToAdd: [etymologyTag],
                tagsToRemove: [],
                replace: false,
            });
        } else {
            await this.updatetags({
                tagsToAdd: [],
                tagsToRemove: [etymologyTag],
                replace: false,
            });
        }

        return null;
    }

    public isSelectedOption(option: ISearchOption): boolean {
        return this.selectedSearchOption && option.optionName === this.selectedSearchOption.optionName;
    }

    public getNrSelectedItems(option: ISearchOption): number {
        return this.searchTags.filter((t) => t.searchType === option.searchType).length;
    }
}
</script>

<style lang="scss"></style>
